import getRequest from "./getRequest.js";
import postRequest from "./postRequest.js";
import config from "config";
import Cookies from "universal-cookie";

const cookies = new Cookies();

async function apiRequest(
  controller = "",
  functionName = "",
  parameters = "",
  method = "GET",
  recaptcha,
  contentType = "application/json",
  authKey = null,
  disableStringify = false,
  apiOrBase = true,
  signal = undefined
) {
  //add culture to request header (according to user url)
  const culture = window.location.pathname.split("/")[1]
    ? window.location.pathname.split("/")[1].substr(0, 2)
    : "en";
  let token;
  //set auth token
  // todo: remove old logic after verifying:
  // if (localStorage.getItem("Auth") != null) {
  //   authKey = JSON.parse(localStorage.getItem("Auth"));
  //   if (authKey != null) {
  //     if (token == null) {
  //       token = authKey.auth;
  //     }
  //   }
  // }
  token = cookies.get(config.api.jumbomailApiAuthCookie);

  if (typeof arguments[0] === "object") {
    const args = arguments[0];
    let withCaptchaServiceName = false;
    if (
      args?.parameters &&
      typeof args?.parameters === "object" &&
      Object.keys(args.parameters).some(
        (param) => param.toLowerCase === "recaptcharesponse"
      )
    ) {
      withCaptchaServiceName = true;
    }
    const params = withCaptchaServiceName
      ? {
          ...args.parameters,
          captchaServiceName: localStorage.getItem("globalCaptchaType"),
        }
      : args.parameters;
    switch (args.method) {
      case "POST":
      case "PUT":
      case "DELETE":
        return await postRequest(
          args.controller,
          args.functionName,
          params,
          args.recaptcha,
          args.contentType === undefined
            ? "application/json"
            : args.contentType,
          token,
          args.disableStringify === undefined ? false : args.disableStringify,
          args.method,
          culture,
          args.apiOrBase === undefined ? true : args.apiOrBase,
          args.signal
        );
      case "GET":
      default:
        return await getRequest(
          args.controller,
          args.functionName,
          params,
          args.contentType === undefined
            ? "application/json"
            : args.contentType,
          token,
          culture,
          args.signal
        );
    }
  } else {
    let withCaptchaServiceName = false;
    if (
      parameters &&
      typeof parameters === "object" &&
      Object.keys(parameters).some(
        (param) => param.toLowerCase() === "recaptcharesponse"
      )
    ) {
      const globalCaptchaType = localStorage.getItem("globalCaptchaType");

      if (globalCaptchaType) {
        withCaptchaServiceName = true;
      }
    }

    const params = withCaptchaServiceName
      ? {
          ...parameters,
          captchaServiceName: localStorage.getItem("globalCaptchaType"),
        }
      : parameters;

    switch (method) {
      case "POST":
      case "PUT":
      case "DELETE":
        return await postRequest(
          controller,
          functionName,
          params,
          recaptcha,
          contentType,
          token,
          disableStringify,
          method,
          culture,
          apiOrBase,
          signal
        );
      case "GET":
      default:
        return await getRequest(
          controller,
          functionName,
          params,
          contentType,
          token,
          culture,
          signal
        );
    }
  }
}

export default apiRequest;
